import { FieldDefinition } from "./fieldDefinitions";

export interface PatientRecordDto {
  patientRecordId: number;
  patientId: number;
  recordId: number;
  familyRecord?: string | null;
  patRecRemarks?: string | null;
  active: boolean;
  dateInserted: string;
  categoryName: string;
  remarks?: string | null;
}

export const patientRecordKeyId = "patientRecordId" as const;

export const patientRecordFormData: string[] = [
  "patientId",
  "recordId",
  "familyRecord",
  "patRecRemarks",
  "active",
  "categoryName",
  "remarks",
];

export const getPatientRecordFields = (
  options: Array<{ value: string | number; label: string }> = [],
): FieldDefinition[] => [
  {
    name: "recordId",
    label: "Κατηγορία Αρχείου",
    type: "select",
    required: true,
    options,
  },
  {
    name: "familyRecord",
    label: "Οικογενειακό Ιστορικό / Αρχείο",
    type: "text",
    required: false,
  },
  {
    name: "patRecRemarks",
    label: "Παρατηρήσεις Ασθενούς",
    type: "text",
    required: false,
  },
  {
    name: "remarks",
    label: "Γενικές Παρατηρήσεις",
    type: "text",
    required: false,
  },
];

export const patientRecordFields = getPatientRecordFields();

export const patientRecordFilters = patientRecordFields.filter((f) =>
  ["recordId", "familyRecord"].includes(f.name),
);
